import React, { useState } from 'react';

const Step4BodyType = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.bodyType || null);

  const options = [
    { value: 'extra-skinny', label: 'Extra Skinny', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page4-Extraskinny.webp' },
    { value: 'skinny', label: 'Skinny', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page4-skinny.webp' },
    { value: 'curvy', label: 'Curvy', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page4-Curvy.webp' },
    { value: 'thick', label: 'Thick', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page4-Thick.webp' }
  ];

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ 
        extraFields: { 
          ...currentData.extraFields, 
          bodyType: value 
        } 
      });
    }, 500);
  };

  return (
    <div className="step step-selection">
      <h2 className="step-title">What kind of figure do you prefer in women?</h2>
      <div className="options-grid grid-2x2">
        {options.map(option => (
          <div
            key={option.value}
            className={`option-card ${selected === option.value ? 'selected' : ''}`}
            onClick={() => handleSelect(option.value)}
          >
            <img src={option.image} alt={option.label} className="option-image" />
            <div className="option-label">{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step4BodyType;